export default __webpack_public_path__ + "static/media/wallart2.ecb9ab54.jpg";